<template>
    <div class="custom-marker-wrapper" :class="open ? 'open' : 'closed'">
        <svg @click="toggle" version="1.1" class="custom-marker" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 24 24" xml:space="preserve">
            <path fill="#ffffff" d="M12,12c-1.2,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3s2.3,1,2.3,2.3S13.2,12,12,12z M18.8,10c0-4.1-3-7-6.8-7
            s-6.8,3-6.8,7c0,2.6,2.2,6.1,6.8,10.3C16.5,16.1,18.8,12.6,18.8,10z M12,0.6c4.8,0,9.1,3.6,9.1,9.3c0,3.7-3.1,8.3-9.1,13.4
            C6,18.2,2.9,13.7,2.9,10C2.9,4.3,7.2,0.6,12,0.6z"/>
        </svg>
    </div>
</template>
<script>
export default {
    props: {
        marker: {
            type: Object,
            required: true
        },
        activeMarker: {
            type: Object,
            default: {}
        },
        isHomePage: {
            type: Boolean,
            default: false
        },
        eventBus: {}
    },

    computed: {
        open() {
            return _.isEqual(this.activeMarker.id, this.marker.id);
        }
    },


    methods: {
        toggle() {
            if (!this.open) {
                this.$emit('marker-clicked', this.marker.geoLocation);
                this.$emit('active-marker', this.marker);
                this.changePageMeta();
                return;
            }

            this.eventBus.$emit('remove-active-marker');
        },

        handleAlive() {
            this.popupItem = this.$refs.markerdetail.$el.getElementsByTagName('a');
        },

        changePageMeta() {
            if (this.isHomePage) {
                return;
            }

            let newPageTitle = this.marker.title + ' | PartsPoint';
            document.title = newPageTitle;
            window.history.pushState({}, newPageTitle, window.location.origin + this.marker.url);
        }
    }
}
</script>
